import React from 'react';
import { Box } from '@mui/material';
import { StringAggregation as StringAggregationType } from '../../redux/types';
import { FormattedAggregatedResult } from './FormattedResult';

type Props = {
  data: StringAggregationType;
}

const StringAggregation: React.FC<Props> = ({
  data,
}: Props) => (
  <Box>
    {
        Object.entries(data.payload.correct).map((
          [key, val],
        ) => (
          <FormattedAggregatedResult
            key={key}
            reviewCount={data.payload.reviewCount}
            text={key}
            total={val}
            fontWeight={500}
          />
        ))
      }
    {
        Object.entries(data.payload.outlier).map((
          [key, val],
        ) => (
          <FormattedAggregatedResult
            key={key}
            reviewCount={data.payload.reviewCount}
            text={key}
            total={val}
          />
        ))
      }
  </Box>
);

export default StringAggregation;
